// Shared top header — used by both web and admin apps
// Logo left, mobile toggle left (hidden on desktop); sticky full-width
// rightContent slot renders user actions on the right

import type { ReactNode } from 'react';
import logo from '../assets/icons/logo-startus.svg';

interface HeaderProps {
  // Mobile-only sidebar/drawer toggle element
  menuToggle?: ReactNode;
  // User action controls rendered on the right (language switcher, profile, logout)
  rightContent?: ReactNode;
}

export function Header({ menuToggle, rightContent }: HeaderProps) {
  return (
    <header
      data-theme="dark"
      className="bg-[#0D0208] text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10 w-full"
    >
      <a href="/">
        <img src={logo} alt="StartUs" className="h-8" />
      </a>
      <div className="flex items-center gap-x-0 md:gap-x-3 text-white">
        {rightContent}
        {menuToggle && <div className="lg:hidden">{menuToggle}</div>}
      </div>
    </header>
  );
}
